'use strict';

import components from './components/core';
import accordion from './components/accordion';
import contacts from './components/contacts';
import cookieConsent from './components/cookie-consent';
import dropdown from './components/dropdown';
import menu from './components/menu';
import pageNavigation from './components/page-navigation';
import searchDropdown from './components/search-dropdown';
import search from './components/search';
import breadcrumbs from './components/breadcrumbs';
import filter from './components/filter';
import eduSearch from './components/edu-search';
import select from './components/select';
import radiogroup from './components/radiogroup';
import checkbox from './components/checkbox';
import autocomplete from './components/autocomplete';
import scrolltotop from './components/scroll-to-top';
import buttonRipple from './components/button-ripple';
import externalSearch from './components/external-search';
import formEvents from './components/form-events';
import handleFilteButtons from './components/handle-filter-buttons';
import searchGenerator from './components/search-generator';
import studentToolbox from './components/student-toolbox';
import staffToolbox from './components/staff-toolbox';
import toolboxTracking from './components/toolbox-tracking';
import linkListTracking from './components/link-list-tracking';
import toggleElement from './components/toggle-elements';
import datePicker from './components/date-picker';
import documentFinder from './components/document-finder';
import floatmenuToolbox from './components/floatmenu-toolbox';
import fileInput from './components/file-input';
import eventValidation from './components/eventform-validation';
import projectValidation from './components/projectform-validation';
import projectFormPeopleSearch from './components/projectform-person-search';
import researchGroupFormPeopleSearch from './components/researchgroupform-person-search';
import researchGroupFormValidation from './components/researchgroupform-validation';
import eventFormPeopleSearch from './components/eventform-person-search';
import scrollDepth from './components/scroll-depth';
import aiChat from './components/ai-chat';

import onlinePayment from './components/online-payment';
import eduSticky from './components/edu-sticky';
import video from './components/video';

// Kickstart the components on the page
components.enhance();

import global from './global';
